import React from 'react'
import { SketchPicker } from 'react-color'

const CustomColorPicker = (props) => {
  const { color, setColor } = props

  return (
    <SketchPicker
      color={color}
      onChangeComplete={(newColor) => setColor(newColor.hex)}
    />
  )
}

export default CustomColorPicker